export default __webpack_public_path__ + "static/prong-collars-3-3a3c396e39df4d07b929d241bd0c1c5c.gif";